// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSharedWebAddressUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSharedWebAddressUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSharedWebAddressUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorSharedWebAddressUpsearchModel.attributeTypeMap = [
    {
        "name": "webAddressId",
        "baseName": "webAddressId",
        "type": "number"
    },
    {
        "name": "webAddressType",
        "baseName": "webAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "string"
    }
];
//# sourceMappingURL=enterpriseCoordinatorSharedWebAddressUpsearchModel.js.map